import { createFileRoute } from '@tanstack/react-router';

import { PlatformSessionListScreen } from '@/features/sessions/components/platform/SessionListScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/platform/sessions/')({
  beforeLoad: () => {
    requirePermission('session:read');
  },
  component: PlatformSessionListScreen,
  staticData: { crumb: 'Sessions' },
});
